// AUTO-GENERATED by scripts/generate-icons.ts. Do not edit by hand.
import {AlterationsIcon} from './alterations-icon'
import {AppleIcon} from './apple-icon'
import {ArrowBackIcon} from './arrow-back-icon'
import {ArrowForwardIcon} from './arrow-forward-icon'
import {ArrowTopRightIcon} from './arrow-top-right-icon'
import {BagIcon} from './bag-icon'
import {BaseStyleIcon} from './base-style-icon'
import {BellIcon} from './bell-icon'
import {BrandPickupIcon} from './brand-pickup-icon'
import {BrandRegisterIcon} from './brand-register-icon'
import {BrandReturnPackageIcon} from './brand-return-package-icon'
import {BuyAgainIcon} from './buy-again-icon'
import {CalendarIcon} from './calendar-icon'
import {CallIcon} from './call-icon'
import {CartIcon} from './cart-icon'
import {CashmereIcon} from './cashmere-icon'
import {ChangeIcon} from './change-icon'
import {CheckIcon} from './check-icon'
import {CheckmarkIcon} from './checkmark-icon'
import {ChevronDownIcon} from './chevron-down-icon'
import {ChevronLeftIcon} from './chevron-left-icon'
import {ChevronRightIcon} from './chevron-right-icon'
import {ChevronUpIcon} from './chevron-up-icon'
import {CircleIcon} from './circle-icon'
import {ClockIcon} from './clock-icon'
import {CloseIcon} from './close-icon'
import {CopyIcon} from './copy-icon'
import {CottonIcon} from './cotton-icon'
import {CsrCo2Icon} from './csr-co2-icon'
import {CsrFairWearIcon} from './csr-fair-wear-icon'
import {CsrZeroWasteIcon} from './csr-zero-waste-icon'
import {CustomMadeIcon} from './custom-made-icon'
import {DeliveryDhlIcon} from './delivery-dhl-icon'
import {DeliveryDpdIcon} from './delivery-dpd-icon'
import {DeliveryFedexIcon} from './delivery-fedex-icon'
import {DeliverySfExpressIcon} from './delivery-sf-express-icon'
import {DeliveryTntIcon} from './delivery-tnt-icon'
import {DeliveryUpsIcon} from './delivery-ups-icon'
import {DeliveryIcon} from './delivery-icon'
import {DocumentIcon} from './document-icon'
import {DotIcon} from './dot-icon'
import {DotsIcon} from './dots-icon'
import {EditIcon} from './edit-icon'
import {EmailIcon} from './email-icon'
import {FacebookIcon} from './facebook-icon'
import {FilterIcon} from './filter-icon'
import {FreeReturnsIcon} from './free-returns-icon'
import {GiftIcon} from './gift-icon'
import {GoogleIcon} from './google-icon'
import {GradientCheckmarkIcon} from './gradient-checkmark-icon'
import {GradientCircleIcon} from './gradient-circle-icon'
import {HideIcon} from './hide-icon'
import {HomeIcon} from './home-icon'
import {InfoCircleIcon} from './info-circle-icon'
import {InfoIcon} from './info-icon'
import {InstagramIcon} from './instagram-icon'
import {LinenIcon} from './linen-icon'
import {LinkedinIcon} from './linkedin-icon'
import {LocationFullIcon} from './location-full-icon'
import {LocationIcon} from './location-icon'
import {LockIcon} from './lock-icon'
import {LogoutIcon} from './logout-icon'
import {LookBuilderIcon} from './look-builder-icon'
import {MenuIcon} from './menu-icon'
import {MessageIcon} from './message-icon'
import {MinusIcon} from './minus-icon'
import {NoneIcon} from './none-icon'
import {PaymentAlipayIcon} from './payment-alipay-icon'
import {PaymentAmexIcon} from './payment-amex-icon'
import {PaymentApplePayIcon} from './payment-apple-pay-icon'
import {PaymentBancontactIcon} from './payment-bancontact-icon'
import {PaymentCreditCardIcon} from './payment-credit-card-icon'
import {PaymentDotpayIcon} from './payment-dotpay-icon'
import {PaymentGiropayIcon} from './payment-giropay-icon'
import {PaymentGooglePayIcon} from './payment-google-pay-icon'
import {PaymentIdealIcon} from './payment-ideal-icon'
import {PaymentKlarnaIcon} from './payment-klarna-icon'
import {PaymentMastercardIcon} from './payment-mastercard-icon'
import {PaymentPaypalIcon} from './payment-paypal-icon'
import {PaymentPaytrailIcon} from './payment-paytrail-icon'
import {PaymentTrustlyIcon} from './payment-trustly-icon'
import {PaymentUnionpayIcon} from './payment-unionpay-icon'
import {PaymentVisaIcon} from './payment-visa-icon'
import {PaymentWechatPayIcon} from './payment-wechat-pay-icon'
import {PersonalAdviceIcon} from './personal-advice-icon'
import {PhoneIcon} from './phone-icon'
import {PickupIcon} from './pickup-icon'
import {PinterestIcon} from './pinterest-icon'
import {PlayIcon} from './play-icon'
import {PlusIcon} from './plus-icon'
import {ProfileIcon} from './profile-icon'
import {QrIcon} from './qr-icon'
import {RecommendedIcon} from './recommended-icon'
import {RefreshIcon} from './refresh-icon'
import {ResetIcon} from './reset-icon'
import {ReturnArrowIcon} from './return-arrow-icon'
import {SearchIcon} from './search-icon'
import {ShareIcon} from './share-icon'
import {ShowIcon} from './show-icon'
import {SilkIcon} from './silk-icon'
import {SizePassportIcon} from './size-passport-icon'
import {StoreAppointmentIcon} from './store-appointment-icon'
import {StoreIcon} from './store-icon'
import {ThumbsDownIcon} from './thumbs-down-icon'
import {ThumbsUpIcon} from './thumbs-up-icon'
import {TiktokIcon} from './tiktok-icon'
import {TrashIcon} from './trash-icon'
import {TwitterIcon} from './twitter-icon'
import {WarningIcon} from './warning-icon'
import {WhatsappIcon} from './whatsapp-icon'
import {WishlistActiveIcon} from './wishlist-active-icon'
import {WishlistOutlineIcon} from './wishlist-outline-icon'
import {WishlistSavedIcon} from './wishlist-saved-icon'
import {WishlistIcon} from './wishlist-icon'
import {WoolIcon} from './wool-icon'
import {XIcon} from './x-icon'
import {YoutubeIcon} from './youtube-icon'
import type {ComponentType, SVGProps} from 'react'

export const iconMap: Record<string, ComponentType<SVGProps<SVGSVGElement>>> = {
  alterations: AlterationsIcon,
  apple: AppleIcon,
  'arrow-back': ArrowBackIcon,
  'arrow-forward': ArrowForwardIcon,
  'arrow-top-right': ArrowTopRightIcon,
  bag: BagIcon,
  'base-style': BaseStyleIcon,
  bell: BellIcon,
  'brand-pickup': BrandPickupIcon,
  'brand-register': BrandRegisterIcon,
  'brand-return-package': BrandReturnPackageIcon,
  'buy-again': BuyAgainIcon,
  calendar: CalendarIcon,
  call: CallIcon,
  cart: CartIcon,
  cashmere: CashmereIcon,
  change: ChangeIcon,
  check: CheckIcon,
  checkmark: CheckmarkIcon,
  'chevron-down': ChevronDownIcon,
  'chevron-left': ChevronLeftIcon,
  'chevron-right': ChevronRightIcon,
  'chevron-up': ChevronUpIcon,
  circle: CircleIcon,
  clock: ClockIcon,
  close: CloseIcon,
  copy: CopyIcon,
  cotton: CottonIcon,
  'csr-co2': CsrCo2Icon,
  'csr-fair-wear': CsrFairWearIcon,
  'csr-zero-waste': CsrZeroWasteIcon,
  'custom-made': CustomMadeIcon,
  'delivery-dhl': DeliveryDhlIcon,
  'delivery-dpd': DeliveryDpdIcon,
  'delivery-fedex': DeliveryFedexIcon,
  'delivery-sf-express': DeliverySfExpressIcon,
  'delivery-tnt': DeliveryTntIcon,
  'delivery-ups': DeliveryUpsIcon,
  delivery: DeliveryIcon,
  document: DocumentIcon,
  dot: DotIcon,
  dots: DotsIcon,
  edit: EditIcon,
  email: EmailIcon,
  facebook: FacebookIcon,
  filter: FilterIcon,
  'free-returns': FreeReturnsIcon,
  gift: GiftIcon,
  google: GoogleIcon,
  'gradient-checkmark': GradientCheckmarkIcon,
  'gradient-circle': GradientCircleIcon,
  hide: HideIcon,
  home: HomeIcon,
  'info-circle': InfoCircleIcon,
  info: InfoIcon,
  instagram: InstagramIcon,
  linen: LinenIcon,
  linkedin: LinkedinIcon,
  'location-full': LocationFullIcon,
  location: LocationIcon,
  lock: LockIcon,
  logout: LogoutIcon,
  'look-builder': LookBuilderIcon,
  menu: MenuIcon,
  message: MessageIcon,
  minus: MinusIcon,
  none: NoneIcon,
  'payment-alipay': PaymentAlipayIcon,
  'payment-amex': PaymentAmexIcon,
  'payment-apple-pay': PaymentApplePayIcon,
  'payment-bancontact': PaymentBancontactIcon,
  'payment-credit-card': PaymentCreditCardIcon,
  'payment-dotpay': PaymentDotpayIcon,
  'payment-giropay': PaymentGiropayIcon,
  'payment-google-pay': PaymentGooglePayIcon,
  'payment-ideal': PaymentIdealIcon,
  'payment-klarna': PaymentKlarnaIcon,
  'payment-mastercard': PaymentMastercardIcon,
  'payment-paypal': PaymentPaypalIcon,
  'payment-paytrail': PaymentPaytrailIcon,
  'payment-trustly': PaymentTrustlyIcon,
  'payment-unionpay': PaymentUnionpayIcon,
  'payment-visa': PaymentVisaIcon,
  'payment-wechat-pay': PaymentWechatPayIcon,
  'personal-advice': PersonalAdviceIcon,
  phone: PhoneIcon,
  pickup: PickupIcon,
  pinterest: PinterestIcon,
  play: PlayIcon,
  plus: PlusIcon,
  profile: ProfileIcon,
  qr: QrIcon,
  recommended: RecommendedIcon,
  refresh: RefreshIcon,
  reset: ResetIcon,
  'return-arrow': ReturnArrowIcon,
  search: SearchIcon,
  share: ShareIcon,
  show: ShowIcon,
  silk: SilkIcon,
  'size-passport': SizePassportIcon,
  'store-appointment': StoreAppointmentIcon,
  store: StoreIcon,
  'thumbs-down': ThumbsDownIcon,
  'thumbs-up': ThumbsUpIcon,
  tiktok: TiktokIcon,
  trash: TrashIcon,
  twitter: TwitterIcon,
  warning: WarningIcon,
  whatsapp: WhatsappIcon,
  'wishlist-active': WishlistActiveIcon,
  'wishlist-outline': WishlistOutlineIcon,
  'wishlist-saved': WishlistSavedIcon,
  wishlist: WishlistIcon,
  wool: WoolIcon,
  x: XIcon,
  youtube: YoutubeIcon,
}

export type IconName =
  | 'alterations'
  | 'apple'
  | 'arrow-back'
  | 'arrow-forward'
  | 'arrow-top-right'
  | 'bag'
  | 'base-style'
  | 'bell'
  | 'brand-pickup'
  | 'brand-register'
  | 'brand-return-package'
  | 'buy-again'
  | 'calendar'
  | 'call'
  | 'cart'
  | 'cashmere'
  | 'change'
  | 'check'
  | 'checkmark'
  | 'chevron-down'
  | 'chevron-left'
  | 'chevron-right'
  | 'chevron-up'
  | 'circle'
  | 'clock'
  | 'close'
  | 'copy'
  | 'cotton'
  | 'csr-co2'
  | 'csr-fair-wear'
  | 'csr-zero-waste'
  | 'custom-made'
  | 'delivery-dhl'
  | 'delivery-dpd'
  | 'delivery-fedex'
  | 'delivery-sf-express'
  | 'delivery-tnt'
  | 'delivery-ups'
  | 'delivery'
  | 'document'
  | 'dot'
  | 'dots'
  | 'edit'
  | 'email'
  | 'facebook'
  | 'filter'
  | 'free-returns'
  | 'gift'
  | 'google'
  | 'gradient-checkmark'
  | 'gradient-circle'
  | 'hide'
  | 'home'
  | 'info-circle'
  | 'info'
  | 'instagram'
  | 'linen'
  | 'linkedin'
  | 'location-full'
  | 'location'
  | 'lock'
  | 'logout'
  | 'look-builder'
  | 'menu'
  | 'message'
  | 'minus'
  | 'none'
  | 'payment-alipay'
  | 'payment-amex'
  | 'payment-apple-pay'
  | 'payment-bancontact'
  | 'payment-credit-card'
  | 'payment-dotpay'
  | 'payment-giropay'
  | 'payment-google-pay'
  | 'payment-ideal'
  | 'payment-klarna'
  | 'payment-mastercard'
  | 'payment-paypal'
  | 'payment-paytrail'
  | 'payment-trustly'
  | 'payment-unionpay'
  | 'payment-visa'
  | 'payment-wechat-pay'
  | 'personal-advice'
  | 'phone'
  | 'pickup'
  | 'pinterest'
  | 'play'
  | 'plus'
  | 'profile'
  | 'qr'
  | 'recommended'
  | 'refresh'
  | 'reset'
  | 'return-arrow'
  | 'search'
  | 'share'
  | 'show'
  | 'silk'
  | 'size-passport'
  | 'store-appointment'
  | 'store'
  | 'thumbs-down'
  | 'thumbs-up'
  | 'tiktok'
  | 'trash'
  | 'twitter'
  | 'warning'
  | 'whatsapp'
  | 'wishlist-active'
  | 'wishlist-outline'
  | 'wishlist-saved'
  | 'wishlist'
  | 'wool'
  | 'x'
  | 'youtube'
